/* ------------------------- External Dependencies -------------------------- */
import React from 'react'

/* ------------------------- Internal Dependencies -------------------------- */
import {
  Flex, Box, 
  Heading, Image, Paragraph, Link, Span, 
  BackgroundImage, BackgroundGradient
} from 'atomic'
/* ------------------------------- Component -------------------------------- */
export default props => 
<Box>

</Box>


// WEBPACK FOOTER //
// ./src/core/containers/ethers/EthersGanacheConnect/component/index.js